import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/roaming'


export default ($axios) => ({
  getPrices (params) {
    return $axios.get(`${resource}/price`, {
      params: {
        ...params
      }
    })
  },
  getCountries () {
    return $axios.get(`${resource}/countries`)
  }
})
